var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"usersView"},[_c('SlidebarUsers',{staticClass:"usersView__slidebar"}),_c('div',{staticClass:"usersView__userSelected"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }